// Map a filename to a Monaco language id + a human-friendly badge label.
// Shared by the file preview surfaces (GitLab workflow files and remote
// storage files) so language detection stays consistent.

const LANG_BY_EXT = {
  py: "python",
  js: "javascript",
  jsx: "javascript",
  mjs: "javascript",
  ts: "typescript",
  tsx: "typescript",
  sh: "shell",
  bash: "shell",
  zsh: "shell",
  yaml: "yaml",
  yml: "yaml",
  json: "json",
  json5: "json",
  md: "markdown",
  markdown: "markdown",
  go: "go",
  rs: "rust",
  rb: "ruby",
  java: "java",
  c: "c",
  h: "c",
  cc: "cpp",
  cpp: "cpp",
  hpp: "cpp",
  toml: "ini",
  ini: "ini",
  cfg: "ini",
  conf: "ini",
  env: "ini",
  html: "html",
  css: "css",
  scss: "scss",
  xml: "xml",
  sql: "sql",
};

export const LANGUAGE_LABEL = {
  python: "Python",
  javascript: "JavaScript",
  typescript: "TypeScript",
  shell: "Shell",
  yaml: "YAML",
  json: "JSON",
  markdown: "Markdown",
  go: "Go",
  rust: "Rust",
  ruby: "Ruby",
  java: "Java",
  c: "C",
  cpp: "C++",
  ini: "Config",
  html: "HTML",
  css: "CSS",
  scss: "SCSS",
  xml: "XML",
  sql: "SQL",
  dockerfile: "Dockerfile",
  plaintext: "Text",
};

export function detectLanguage(name) {
  const lower = (name || "").toLowerCase();
  if (lower.startsWith("dockerfile")) return "dockerfile";
  const ext = lower.includes(".") ? lower.split(".").pop() : "";
  return LANG_BY_EXT[ext] || "plaintext";
}

export function languageLabel(name) {
  return LANGUAGE_LABEL[detectLanguage(name)] || "Text";
}
